import React from 'react';
import { connectStats } from 'react-instantsearch-dom';

const Stats = ({ isGeoSearchResult, resultHeadingNote, nbHits }) => {
    const statInfo = isGeoSearchResult ? 'results, sorted by distance from your search location' : 'results found';
    return (
        <div className="result-count-info">
            <p className="bl-custom-stats">{nbHits.toLocaleString()} {statInfo}</p>
            {resultHeadingNote && nbHits.toLocaleString() && (
                <p className="result-count-note">
                    {resultHeadingNote}
                </p>
            )}
        </div>
    );
};

const CustomStats = connectStats(Stats);

export default CustomStats;
